// extracted by mini-css-extract-plugin
export default {"carousel":"PG-z"};